import React from 'react'
import { connect } from 'react-redux'
import AuthStripe from '~/Common-Objects/UI/Payment/confirmCardPayment'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import axios from '~/data/http/axios'
import NumberFunctions from '~/Classes/numberFormatFunctions'
import DateFunctions from '~/Classes/dateTimeFunctions'
import StripeAddCard from './stripeAddCard'
import i18n from '~/i18n'
//CONNECT TO STORE

@connect((store) => {
  return { user: store.user, accountMaster: store.accountMaster }
})
export default class UpgradeDrawer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      accountMaster: {},
      pageLoaded: false,
      changingPlan: false,
      plans: [],
      creditPlans: [],
      currentBilling: {},
      newPlanId: -1,
      newPlan: {},
      voucherCode: '',
      currentVoucher: '',
      paymentMethod: '',
      paymentCards: [],
      manuallyAddingCard: false,
      paymentCardId: '',
      paymentError: '',
      defaultCard: '',
      billingFrequency: -1,
      voucherError: '',
      stripeAuthPayment: undefined,
      reloadingCard: false,
      credits: 0
    }

    this.loadPlans = this.loadPlans.bind(this)
    this.changePlan = this.changePlan.bind(this)
    this.loadCurrentBilling = this.loadCurrentBilling.bind(this)

    this.loadAccountMaster = this.loadAccountMaster.bind(this)
    this.changeInput = this.changeInput.bind(this)
    this.checkVoucher = this.checkVoucher.bind(this)
    this.getPaymentCards = this.getPaymentCards.bind(this)
    this.addNewCard = this.addNewCard.bind(this)
    this.selectCard = this.selectCard.bind(this)
    this.goChangePlan = this.goChangePlan.bind(this)
    this.changeFrequency = this.changeFrequency.bind(this)
    this.loadCreditPlans = this.loadCreditPlans.bind(this)

    this.completePaymentIntent = this.completePaymentIntent.bind(this)
    this.errorPaymentIntent = this.errorPaymentIntent.bind(this)
    this.changeCredits = this.changeCredits.bind(this)
  }

  componentDidMount() {
    this.loadAccountMaster()
  }

  loadAccountMaster() {
    axios.get('/accountMaster').then((res) => {
      this.setState({ accountMaster: res.data.AccountMaster, changingPlan: true }, this.loadCurrentBilling)
    })
  }
  loadCurrentBilling() {
    axios.get('/accountMaster/usage').then((response) => {
      response.data.Billing.friendlyPriceRaw = response.data.Billing.friendlyPrice
      this.setState(
        {
          currentBilling: response.data.Billing
        },
        this.loadCreditPlans
      )
    })
  }

  loadPlans() {
    var self = this
    var plans = []
    axios
      .get('/accountMaster/plan')
      .then((response) => {
        plans = response.data.Plans
        return axios.get('/site/freePlan')
      })
      .then((_res) => {
        if (!plans.some((p) => p.id === _res.data.id)) {
          _res.data.friendlyPrice = 0
          _res.data.friendlyPriceRaw = 0
          _res.data.symbol = plans[0].symbol
          _res.data.isFree = true
          plans.unshift(_res.data)
        }
        this.setState(
          {
            plans: plans,
            pageLoaded: true
          },
          this.getPaymentCards
        )
      })
      .catch((err) => {
        console.log(err)
      })
  }

  loadCreditPlans() {
    axios.get('/accountMaster/plan?type=1').then((response) => {
      this.setState(
        {
          creditPlans: response.data.Plans
        },
        this.loadPlans
      )
    })
  }

  getPaymentCards(skip) {
    axios
      .get('/accountMaster/paymentMethod/stripe')
      .then((response) => {
        var defaultCard
        var paymentMethod
        if (response.data.customer && response.data.customer.default_source) {
          defaultCard = response.data.customer.default_source
          paymentMethod = 'card'
        }

        this.setState(
          {
            manuallyAddingCard: false,
            paymentCards: response.data.customer.sources.data,
            defaultCard,
            paymentCardId: defaultCard,
            paymentMethod
          },
          () => (!skip ? this.changePlan(null, true) : undefined)
        )
      })
      .catch(console.log)
  }

  changePlan(event, override) {
    var _event = event
    var newPlanId
    if (_event) {
      newPlanId = _event.target.value
    } else if (!override) {
      return
    } else {
      newPlanId = this.state.newPlanId
    }

    this.setState({
      newPlanId,
      changingPlan: true
    })
    if (newPlanId > -1) {
      axios
        .get(
          '/accountMaster/plan/' +
            newPlanId +
            '?billingFrequency=' +
            this.state.billingFrequency +
            (this.state.billingFrequency == 2 ? '&credits=' + this.state.credits : '')
        )
        .then((response) => {
          this.setState({
            newPlan: response.data,
            changingPlan: false
          })
        })
    }
  }

  changeInput(event) {
    var state = this.state
    this.state[event.target.name] = event.target.value
    this.setState(state)
  }

  checkVoucher() {
    axios
      .get('/voucherCode/' + this.state.voucherCode)
      .then((_res) => {
        if (_res.data.VoucherCode && _res.data.VoucherCode.used) {
          this.setState({ currentVoucher: undefined, voucherError: 'Voucher previously used' })
          return
        }
        this.setState({ currentVoucher: _res.data.VoucherCode, voucherError: '' })
      })
      .catch(() => {
        this.setState({ currentVoucher: undefined, voucherError: 'Invalid or Expired voucher code' })
      })
  }

  addNewCard() {
    var manuallyAddingCard = this.state.manuallyAddingCard
    if (manuallyAddingCard) {
      manuallyAddingCard = false
    } else {
      manuallyAddingCard = true
    }
    this.setState({ manuallyAddingCard, paymentCardId: '' })
  }

  selectCard(event) {
    var self = this
    var newCardId = event.target.value
    this.setState({ reloadingCard: true })
    axios
      .put('/accountMaster/paymentMethod/stripe', {
        default_source: newCardId
      })
      .then(() => {
        self.setState({ manuallyAddingCard: false, paymentCardId: newCardId, reloadingCard: false })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  goChangePlan() {
    this.setState({
      pageLoaded: false
    })
    var ourPlan = this.state.newPlan
    var voucherCode = undefined
    if (this.state.voucherCode) voucherCode = this.state.voucherCode

    axios
      .put('/accountMaster/plan', {
        planId: this.state.newPlanId ? this.state.newPlanId : -1,
        accountType: ourPlan.isFree ? 'free' : 'paid',
        voucherCode: voucherCode,
        frequencyId: Number(this.state.billingFrequency),
        credits: this.state.credits
      })
      .then((response) => {
        if (response.data.clientSecret) {
          this.setState({
            stripeAuthPayment: response.data
          })
        } else {
          this.props.close()
        }
      })
      .catch((err) => {
        var error = 'There was a problem processing your payment'

        if (err.data && err.data.error) error = err.data.error
        this.setState({
          pageLoaded: true,
          paymentError: error
        })
      })
  }

  changeFrequency(event) {
    let newFrequency = Number(event.target.value)
    this.setState({ billingFrequency: newFrequency, currentVoucher: '', voucherCode: '', voucherError: '' }, () => {
      this.changePlan(null, true)
    })
  }

  completePaymentIntent() {
    axios
      .put('/accountMaster/payment/stripeauth/' + this.state.stripeAuthPayment.OrderId)
      .then(() => {
        this.setState({
          alertOpen: true,
          alertMessage: 'Plan Switched',
          processingPayment: false,
          pageLoaded: true,
          stripeAuthPayment: undefined
        })
        this.props.close()
      })
      .catch((err) => {
        console.log(err)
        this.setState({
          paymentError: err.response.message || err.response,
          pageLoaded: true
        })
      })
  }

  errorPaymentIntent(err) {
    // delete the order
    axios.delete('/accountMaster/payment/' + this.state.stripeAuthPayment.OrderId + '?error=' + err).catch(() => {})
    this.setState({
      pageLoaded: true,
      stripeAuthPayment: undefined,
      paymentError: err
    })
  }

  changeCredits(ev) {
    var credits = parseInt(ev.currentTarget.value)
    if (isNaN(credits)) credits = 0
    this.setState({
      credits
    })

    if (this.creditsTimer) clearTimeout(this.creditsTimer)
    this.creditsTimer = setTimeout(() => {
      var foundPlan

      this.state.creditPlans.forEach((plan) => {
        if (plan.maxUniqueSends >= credits) {
          if (!foundPlan || foundPlan.maxUniqueSends >= plan.maxUniqueSends) {
            foundPlan = plan
          }
        }
      })
      this.setState({
        newPlan: foundPlan,
        newPlanId: foundPlan ? foundPlan.id : undefined,
        changingPlan: true
      })

      axios.get('/accountMaster/plan/' + foundPlan.id + '?credits=' + credits).then((response) => {
        this.setState(
          {
            newPlan: response.data,
            newPlanId: foundPlan.id,
            changingPlan: false
          },
          () => {
            console.log(this.state)
          }
        )
      })
    }, 200)
  }

  render() {
    if (this.state.stripeAuthPayment)
      return (
        <AuthStripe
          paymentMethod={this.state.stripeAuthPayment.paymentMethod}
          clientSecret={this.state.stripeAuthPayment.clientSecret}
          success={this.completePaymentIntent}
          error={this.errorPaymentIntent}
        />
      )
    if (!this.state.pageLoaded) return <LoadingIcons iconType='2' />

    var newPlan = {}
    var currPlan = this.state.currentBilling

    var currPlanExpires = this.props.accountMaster.accountMaster.nextBillDate

    var finalPrice = 0
    var finalPriceRaw = 0
    var discount = 0
    var voucherDiscount = 0
    var vatAmt = 0
    var currentSubDiscount = 0

    if (this.state.newPlanId != -1 && this.state.billingFrequency > -1) {
      newPlan = this.state.newPlan
      finalPriceRaw = Number(newPlan.price)
      currentSubDiscount = Number(newPlan.discount) || 0

      if (discount < 0) discount = 0
      if (currentSubDiscount < 0) currentSubDiscount = 0

      if (newPlan.changeNow) {
        finalPrice = finalPriceRaw - discount - currentSubDiscount
        if (this.state.currentVoucher && this.state.currentVoucher.voucherValue > 0) {
          voucherDiscount = (finalPrice / 100) * this.state.currentVoucher.voucherValue
          finalPrice = finalPrice - voucherDiscount
        }
      } else {
        finalPrice = finalPriceRaw
      }
      if (this.state.accountMaster.addVAT) {
        vatAmt = (finalPrice / 100) * 20
      }
      finalPrice = finalPrice + vatAmt
    }

    var selectedPaymentCard = this.state.paymentCardId
    if (!selectedPaymentCard || !selectedPaymentCard.length) selectedPaymentCard = this.state.defaultCard

    let changingPlanMech = null

    let currPlanMonthlyLimitTxt = (
      <span>{i18n.t('company:upgrade.uniqueEmailsPerMonth', { count: NumberFunctions.formatNumber(currPlan.maxUniqueSends) })}</span>
    )
    let newPlanMonthlyLimitTxt = (
      <span>{i18n.t('company:upgrade.sendToUniqueEmailsPerMonth', { count: NumberFunctions.formatNumber(newPlan.maxUniqueSends) })}</span>
    )
    if (this.state.billingFrequency == 1) {
      newPlanMonthlyLimitTxt = (
        <span>{i18n.t('company:upgrade.sendToUniqueEmailsPerYear', { count: NumberFunctions.formatNumber(newPlan.maxUniqueSends) })}</span>
      )
    }

    if (this.props.accountMaster.accountMaster.billedOnContacts) {
      currPlanMonthlyLimitTxt = <span>{i18n.t('company:upgrade.contactLimit', { count: NumberFunctions.formatNumber(currPlan.maxUniqueSends) })}</span>
    }

    if (this.state.billingFrequency < 2 && newPlan.price > 0) {
      newPlanMonthlyLimitTxt = <span>{i18n.t('company:upgrade.contacts', { count: NumberFunctions.formatNumber(newPlan.maxUniqueSends) })}</span>
    }

    //displays the billing message to let them know they are changing from contacts to sends depending on which plan they are going for
    if (
      this.props.accountMaster.accountMaster.billedOnContacts == 0 &&
      this.state.billingFrequency < 2 &&
      newPlan.price > 0
    ) {
      changingPlanMech = 'contacts'
    }
    if (
      this.props.accountMaster.accountMaster.billedOnContacts == 1 &&
      this.state.billingFrequency < 2 &&
      newPlan.price == 0
    ) {
      changingPlanMech = 'sends'
    }

    let availablePlans = this.state.plans.filter((plan) => {
      //check they dont already have this plan
      if (plan.id == this.props.accountMaster.accountMaster.AccountBillingId) {
        //and they are already on the same frequency
        if (this.props.accountMaster.accountMaster.billingFrequency == this.state.billingFrequency) {
          return false
        }
      }
      return true
    })

    return (
      <div>
        <h4 className='mar-b25'>{i18n.t('company:upgrade.title')}</h4>

        {this.state.paymentError && this.state.paymentError.length > 0 && (
          <div className='mar-b20 text-red'>{this.state.paymentError}</div>
        )}

        <Row>
          {this.props.accountMaster.accountMaster.billingFrequency !== 2 && (
            <Column xs={12} margin={0}>
              <Paper className='paper-secondary'>
                <p className='mar-b10'>{i18n.t('company:upgrade.yourCurrentPlan')}</p>
                <Row>
                  <Column xs={12} sm={7} margin={0}>
                    <div className='mar-b5'>{currPlan.name}</div>
                    <div className='text-xsml'>{currPlanMonthlyLimitTxt}</div>
                    {this.state.newPlanId != -1 && (
                      <div className='text-xsml'>
                        {i18n.t('company:upgrade.nextPaymentDue', { date: DateFunctions.formatDateTime(currPlanExpires, 2) })}
                      </div>
                    )}
                  </Column>
                  <Column xs={12} sm={5} className='text-right' margin={0}>
                    {currPlan.symbol + NumberFunctions.formatNumber(currPlan.friendlyPriceRaw, 2)} {i18n.t('company:upgrade.perMonth')}
                  </Column>
                </Row>
              </Paper>
            </Column>
          )}

          <Column xs={12} margin={0}>
            <Paper className='paper-primary'>
              <p className='mar-b10 text-white' style={{ fontWeight: '600' }}>
                {i18n.t('company:upgrade.yourNewPlan')}
              </p>
              <Row>
                <Column xs={12} margin={this.state.billingFrequency === -1 ? 0 : undefined}>
                  <div className='form-group mar-b5'>
                    <Select
                      value={this.state.billingFrequency}
                      placeholder={i18n.t('company:upgrade.selectBillingFrequency')}
                      onChange={this.changeFrequency}
                      data={[
                        { label: i18n.t('company:upgrade.billingMonthly'), value: 0 },
                        { label: i18n.t('company:upgrade.billingAnnually'), value: 1 },
                        { label: i18n.t('company:upgrade.billingPayAsYouGo'), value: 2 }
                      ]}
                    />
                  </div>
                </Column>
              </Row>

              {this.state.billingFrequency != -1 && this.state.billingFrequency != 2 && (
                <Row>
                  <Column xs={12} sm={this.state.newPlanId != -1 ? 7 : 12} margin={0}>
                    <div className='form-group mar-b5'>
                      <Select
                        placeholder={i18n.t('company:upgrade.selectNewPlan')}
                        value={this.state.newPlanId}
                        onChange={this.changePlan}
                        data={availablePlans.map((plan) => {
                          return { value: plan.id, label: plan.name }
                        })}
                      />
                    </div>
                  </Column>

                  {this.state.newPlanId != -1 && !isNaN(finalPriceRaw) && (
                    <Column xs={12} sm={5} className='text-right' margin={0}>
                      {newPlan.symbol + NumberFunctions.formatNumber(finalPriceRaw, 2)}{' '}
                      {this.state.billingFrequency == 1 ? i18n.t('company:upgrade.perYear') : i18n.t('company:upgrade.perMonth')}
                    </Column>
                  )}

                  {this.state.newPlanId != -1 && (
                    <Column xs={12} margin={0}>
                      <div className='text-xsml'>{newPlanMonthlyLimitTxt}</div>
                    </Column>
                  )}
                  {this.state.newPlanId != -1 &&
                    this.props.accountMaster.accountMaster.billingFrequency == 2 &&
                    this.props.accountMaster.accountMaster.credits > 0 && (
                      <Column xs={12} className='mar-t10' margin={0}>
                        <div className='text-xsml'>
                          {i18n.t('company:upgrade.remainingCreditsUsed', { count: NumberFunctions.formatNumber(this.props.accountMaster.accountMaster.credits) })}{' '}
                        </div>
                      </Column>
                    )}
                </Row>
              )}

              {this.state.billingFrequency == 2 && (
                <Row>
                  <Column xs={12} margin={0}>
                    <div className='form-group'>
                      <label htmlFor=''>{i18n.t('company:upgrade.numberOfCredits')}</label>
                      <TextInput type='number' value={this.state.credits} onChange={this.changeCredits} />
                    </div>
                  </Column>
                  <Column xs={12} margin={0}>
                    {i18n.t('company:upgrade.payAsYouGoDescPlain')}
                  </Column>
                </Row>
              )}
            </Paper>
          </Column>
        </Row>
        {changingPlanMech && (
          <Row>
            <Column xs={12}>
              <Paper style={{ border: '2px solid red' }}>
                {changingPlanMech == 'contacts' && (
                  <div>
                    {i18n.t('company:upgrade.changingToContacts')}
                  </div>
                )}
                {changingPlanMech == 'sends' && (
                  <div>
                    {i18n.t('company:upgrade.changingToSends')}
                  </div>
                )}
              </Paper>
            </Column>
          </Row>
        )}

        {this.state.newPlanId != -1 && newPlan.changeNow && !isNaN(finalPrice) && (
          <div>
            {this.state.changingPlan && (
              <Row>
                <Column xs={12}>
                  <LoadingIcons iconType='2' />
                </Column>
              </Row>
            )}
            {!this.state.changingPlan && (
              <div>
                {this.state.billingFrequency != 1 && (
                  <Row margin={0}>
                    <Column xs={12} sm={9} margin={0} className='mar-b20'>
                      <div className='form-group mar-b0'>
                        <TextInput
                          name='voucherCode'
                          placeholder={i18n.t('company:upgrade.voucherCode')}
                          value={this.state.voucherCode}
                          onChange={this.changeInput}
                          error={this.state.voucherError}
                        />
                      </div>
                    </Column>
                    <Column xs={12} sm={3} margin={0} className=' mar-b20 text-right'>
                      <Button text={i18n.t('company:upgrade.apply')} onClick={this.checkVoucher} className='button-sml full-width' />
                    </Column>
                  </Row>
                )}

                <Row>
                  <Column xs={12} sm={12} margin={0}>
                    <Row>
                      <Column xs={8} margin={0} className='mar-b10 text-right text-sml'>
                        {i18n.t('company:upgrade.planPrice')}
                      </Column>
                      <Column xs={4} margin={0} className='mar-b10 text-right text-sml'>
                        {newPlan.symbol}
                        {NumberFunctions.formatNumber(finalPriceRaw, 2)}
                      </Column>
                    </Row>
                    {discount > 0 && (
                      <Row>
                        <Column xs={8} margin={0} className='mar-b10 text-right text-sml'>
                          {i18n.t('company:upgrade.discount')}
                        </Column>
                        <Column xs={4} margin={0} className='mar-b10 text-right text-sml'>
                          - {newPlan.symbol}
                          {NumberFunctions.formatNumber(discount, 2)}
                        </Column>
                      </Row>
                    )}
                    {currentSubDiscount > 0 && (
                      <Row>
                        <Column xs={8} margin={0} className='mar-b10 text-right text-sml'>
                          {i18n.t('company:upgrade.currentSubDiscount')}
                        </Column>
                        <Column xs={4} margin={0} className='mar-b10 text-right text-sml'>
                          - {newPlan.symbol}
                          {NumberFunctions.formatNumber(currentSubDiscount, 2)}
                        </Column>
                      </Row>
                    )}
                    {voucherDiscount > 0 && (
                      <Row>
                        <Column xs={8} margin={0} className='mar-b10 text-right text-sml'>
                          {i18n.t('company:upgrade.voucher')}
                        </Column>
                        <Column xs={4} margin={0} className='mar-b10 text-right text-sml'>
                          - {newPlan.symbol}
                          {NumberFunctions.formatNumber(voucherDiscount, 2)}
                        </Column>
                      </Row>
                    )}
                    {this.state.accountMaster.addVAT && (
                      <Row>
                        <Column xs={8} margin={0} className='mar-b10 text-right text-sml'>
                          {i18n.t('company:upgrade.vat')}
                        </Column>
                        <Column xs={4} margin={0} className='mar-b10 text-right text-sml'>
                          + {newPlan.symbol}
                          {NumberFunctions.formatNumber(vatAmt, 2)}
                        </Column>
                      </Row>
                    )}
                    <Row>
                      <Column xs={8} className='text-right text-sml'>
                        {i18n.t('company:upgrade.totalToPayNow')}
                      </Column>
                      <Column xs={4} className='text-lg text-right'>
                        {newPlan.symbol}
                        {NumberFunctions.formatNumber(finalPrice, 2)}
                      </Column>
                    </Row>
                  </Column>

                  {finalPrice > 0 && (
                    <div style={{ width: '100%' }}>
                      <Column xs={12} margin={0}>
                        <div className='form-group'>
                          <Select
                            name='paymentMethod'
                            value={this.state.paymentMethod}
                            placeholder={i18n.t('company:upgrade.selectPaymentMethod')}
                            data={[{ label: i18n.t('company:upgrade.creditDebitCard'), value: 'card' }]}
                            onChange={this.changeInput}
                          />
                        </div>
                      </Column>

                      {this.state.paymentMethod &&
                        this.state.paymentMethod == 'card' &&
                        this.state.paymentCards &&
                        this.state.paymentCards.length > 0 &&
                        !this.state.manuallyAddingCard && (
                          <Column xs={12} margin={0} className='mar-b20'>
                            {!!this.state.reloadingCard && <LoadingIcons iconType='2' />}
                            {!this.state.reloadingCard && (
                              <div className='form-group mar-b0'>
                                <Select
                                  placeholder={i18n.t('company:upgrade.selectExistingCard')}
                                  data={this.state.paymentCards.map((card) => {
                                    return {
                                      label: i18n.t('company:stripeCard.cardEndingExp', {
                                        brand: card.brand,
                                        last4: card.last4,
                                        month: card.exp_month,
                                        year: card.exp_year
                                      }),
                                      value: card.id
                                    }
                                  })}
                                  onChange={this.selectCard}
                                  value={selectedPaymentCard}
                                />
                                <div className='mar-t10' style={{ textAlign: 'right', fontSize: '14px' }}>
                                  {i18n.t('company:upgrade.orAddNewCard')} <a onClick={this.addNewCard}>{i18n.t('company:upgrade.addNewCard')}</a>
                                </div>
                              </div>
                            )}
                          </Column>
                        )}

                      {this.state.paymentMethod &&
                        this.state.paymentMethod == 'card' &&
                        (!this.state.paymentCards ||
                          !this.state.paymentCards.length ||
                          this.state.manuallyAddingCard) && (
                          <Column xs={12} margin={0}>
                            <StripeAddCard
                              close={() => this.getPaymentCards(true)}
                              hasCloseButton={this.state.manuallyAddingCard}
                            />
                          </Column>
                        )}
                    </div>
                  )}
                  {(finalPrice == 0 || (this.state.paymentCardId && this.state.paymentCardId.length > 0)) && (
                    <Column xs={12} margin={0}>
                      <p className='mar-b20'>
                        {i18n.t('company:upgrade.termsContinue')}{' '}
                        {this.state.billingFrequency < 2 && (
                          <span>
                            {i18n.t('company:upgrade.cardBilledEvery', {
                              symbol: newPlan.symbol,
                              amount: NumberFunctions.formatNumber(finalPriceRaw, 2),
                              period: this.state.billingFrequency == 1 ? i18n.t('company:upgrade.year') : i18n.t('company:upgrade.thirtyDays')
                            })}
                          </span>
                        )}
                      </p>
                      {this.state.paymentError && this.state.paymentError.length > 0 && (
                        <div className='mar-b20 text-red'>{this.state.paymentError}</div>
                      )}
                      <Button
                        className='button-md'
                        text={i18n.t('company:upgrade.payAmount', { symbol: newPlan.symbol, amount: NumberFunctions.formatNumber(finalPrice, 2) })}
                        onClick={this.goChangePlan}
                      />
                    </Column>
                  )}
                </Row>
              </div>
            )}
          </div>
        )}

        {this.state.newPlanId != -1 && !newPlan.changeNow && !isNaN(finalPrice) && (
          <div>
            <Row>
              <Column xs={12}>
                <p className='text-md center-xs'>{i18n.t('company:upgrade.downgradingAccount')}</p>
                {!!finalPrice && (
                  <p className='center-xs'>
                    {i18n.t('company:upgrade.notChargedNow', {
                      symbol: newPlan.symbol,
                      amount: NumberFunctions.formatNumber(finalPriceRaw, 2),
                      days: NumberFunctions.formatNumber(newPlan.daysRemaining)
                    })}
                  </p>
                )}
              </Column>
              <Column xs={12} className='center-xs'>
                <Button text={i18n.t('company:upgrade.downgrade')} onClick={this.goChangePlan} className='button-md' />
              </Column>
            </Row>
          </div>
        )}
      </div>
    )
  }
}
